import React, { forwardRef } from "react";
import PropTypes from "prop-types";

const TextInput = forwardRef(({ className = "", readOnly = false, ...props }, ref) => (
  <input {...props} className={["wsm-input", className].filter(Boolean).join(" ")} readOnly={readOnly} ref={ref} />
));

TextInput.displayName = "TextInput";
TextInput.propTypes = {
  className: PropTypes.string,
  readOnly: PropTypes.bool,
  type: PropTypes.oneOf(["text", "email", "password", "search", "tel", "url", "number", "date", "datetime-local", "time"]),
};

export default TextInput;
